/* eslint-disable no-new */
import {Form} from './form';

function insertHtml(e, html) {
	const newForm = document.createElement('div');
	newForm.innerHTML = html;
	e.target.insertAdjacentElement('beforebegin', newForm);
	new Form(newForm.querySelector('.form'));
}

function addNewForm(e) {
	const url = '/ajax/new-form.php';

	fetch(url, {
		method: 'get',
	}).then((response) => {
		if (response.status < 200 || response.status > 300) {
			let error = new Error(response.statusText);
			error.response = response;
			throw error;
		} else {
			return response.text();
		}
	// eslint-disable-next-line arrow-parens
	}).then(res => {
		insertHtml(e, res);
	});
}

function init() {
	const btnAdd = document.getElementById('add-form-project');

	if (btnAdd) {
		btnAdd.addEventListener('click', addNewForm);
	}
}

export default {
	init,
};
